import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static classes = ["open"]

    connect() {
        this._handleOpen = this.open.bind(this)
        this.element.addEventListener('notice-modal:open', this._handleOpen)
    }

    disconnect() {
        this.element.removeEventListener('notice-modal:open', this._handleOpen)
    }

    open() {
        this.element.classList.add(this.openClass)
        document.body.style.overflow = "hidden"

        const closeBtn = this.element.querySelector(".modal__close")
        if (closeBtn) {
            closeBtn.focus()
        }
    }

    close() {
        this.element.classList.remove(this.openClass)
        document.body.style.overflow = ""
    }

    closeWithParentModal() {
        this.element.classList.remove(this.openClass)
        document.body.style.overflow = ""

        document.dispatchEvent(new CustomEvent('notice-modal:confirmed'))
    }

    closeOnOverlay(event) {
        if (event.target === this.element) {
            this.close()
        }
    }

    stopPropagation(event) {
        event.stopPropagation()
    }
}
